(function ($) {
  "use strict";

  window.autoCartAddProduct = {};

  var $document = $(document),
    isAddingProduct = false,
    isCheckingCart = false,
    page_type = T4Srequest.page_type,
    cartTypeIsDisable = T4Sconfigs.cartType == "disable",
    strCartDataMini = cartTypeIsDisable ? "cart_data" : "cart_data,mini_cart",
    sections_nt =
      page_type != "cart"
        ? strCartDataMini
        : `cart_data,${window.cartT4SectionID}`;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    try {
      const response = await originalFetch(...args);

      if (args[0].includes("/cart/add")) {
        await isCartGreaterThanTwo();
      }
      return response;
    } catch (error) {
      console.error("Error in custom fetch:", error);
      throw error;
    }
  };

  async function isCartGreaterThanTwo() {
    if (isCheckingCart) return;
    isCheckingCart = true;

    const cart = await fetchCart();
    
    if (cart && cart.items.length >= 2) {
      const collectionIds = window.autoCartAddProduct.collections;
      const productIds = Object.keys(window.autoCartAddProduct.products);

      const itemsInCart = cart.items.map((item) => ({
        productId: item.product_id,
        variantId: item.variant_id,
        properties: item.properties || {},
      }));

      const hasMatchingCollection = itemsInCart.some((item) =>
        collectionIds.includes(item.productId)
      );
      const hasMatchingVariant = itemsInCart.some((item) => {
        return productIds.some((productId) => {
          const productVariants = window.autoCartAddProduct.products[productId]?.variants || [];
          return productVariants.includes(item.variantId);
        });
      });

      const hasPersonalization = itemsInCart.some(
        (item) => item.properties?.personalize === "yes"
      );

      if (hasMatchingCollection && hasMatchingVariant && !isAddingProduct) {
      
        // setTimeout(() => {
        //   addToCart(41159879196718, 1);
        // }, 1500);

        if (hasPersonalization) {
          console.log("Personalized item found — delaying addToCart");
          setTimeout(() => {
             addToCart(41159879196718, 1);
             isAddingProduct = true;
          }, 1500);
        } else {
          await addToCart(41159879196718, 1);
          isAddingProduct = true;
        }

        
      } 
      else {
        console.log(
          "No matching collection or variant items found in the cart."
        );
      }
    } else {
      console.log("No cart data");
    }
    isCheckingCart = false;
  }

  async function fetchCart() {
    try {
      const response = await fetch("/cart.js", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching cart:", error);
      return null;
    }
  }

  // function addToCart(variantId, quantity) {
  //   const data = {
  //     id: variantId,
  //     quantity: quantity,
  //     sections: sections_nt,
  //     sections_url: window.location.pathname,
  //   };

  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       return response.json();
  //     })
  //     .then((response) => {
  //       if (response.status && response.status !== 200) {
  //         handleErrorMessage(response.responseJSON.description);
  //         $document.trigger("cart:updated");
  //         isAddingProduct = false;
  //         return;
  //       }

  //       console.log("Product added to cart successfully:", response);
  //       $document.trigger("add:cart:success").trigger("add:cart:upsell");
  //       if (
  //         T4SThemeSP &&
  //         T4SThemeSP.Cart &&
  //         typeof T4SThemeSP.Cart.renderContents === "function"
  //       ) {
  //         T4SThemeSP.isATCSuccess = true;
  //         T4SThemeSP.Cart.renderContents(response.sections);
  //       }
  //       isAddingProduct = false;
  //     })
  //     .catch((error) => {
  //       console.error("Error adding product to cart:", error);
  //       isAddingProduct = false;
  //     });
  // }

  function addToCart(variantId, quantity) {
    const data = {
      id: variantId,
      quantity: quantity,
      sections: sections_nt,
      sections_url: window.location.pathname,
    };
  
    
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((response) => {
        if (response.status && response.status !== 200) {
          handleErrorMessage(response.responseJSON.description);
          $document.trigger("cart:updated");
          isAddingProduct = false;
          return;
        }

        $document.trigger("add:cart:success").trigger("add:cart:upsell");
        if (
          T4SThemeSP &&
          T4SThemeSP.Cart &&
          typeof T4SThemeSP.Cart.renderContents === "function"
        ) {
          T4SThemeSP.isATCSuccess = true;
          T4SThemeSP.Cart.renderContents(response.sections);
        }
        isAddingProduct = false;
      })
      .catch((error) => {
        console.error("Error adding product to cart:", error);
        isAddingProduct = false;
      });
  }


  /////////// graphql for data fetch //////////////
  async function fetchGraphQL(data) {
    try {
      const response = await $.ajax({
        url: `${window.location.origin}/api/2024-07/graphql.json`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "511ca77b91e8920adf9044fb1ca07581",
        },
        data: JSON.stringify(data),
      });
      return response;
    } catch (error) {
      console.error("GraphQL request failed:", error);
      throw error;
    }
  }
  async function fetchProducts(collectionID) {
    try {
      const response = await fetchGraphQL({
        query: `{
                      collection(id: "gid://shopify/Collection/${collectionID}") {
                          products(first: 150) {
                              edges {
                                  node {
                                      id
                                  }
                              }
                          }
                      }
                  }`,
      });
      const productIds =
        response?.data?.collection?.products?.edges?.map(
          (edge) => edge.node.id
        ) || [];
      const cleanedProductIds = productIds
        .map((id) => id.replace("gid://shopify/Product/", "")) // Remove the prefix
        .map((id) => parseInt(id, 10));

      return cleanedProductIds;
    } catch (error) {
      console.error(
        `Failed to fetch products for collection ${collectionID}:`,
        error
      );
      return [];
    }
  }

  async function fetchVariants(productID) {
    try {
      const response = await fetchGraphQL({
        query: `{
                  product(id: "gid://shopify/Product/${productID}") {
                      variants(first: 50) {
                          edges {
                              node {
                                  id
                              }
                          }
                      }
                  }
              }`,
      });
      const variantIds =
        response?.data?.product?.variants?.edges?.map((edge) => edge.node.id) ||
        [];
      const cleanedVariantIds = variantIds
        .map((id) => id.replace("gid://shopify/ProductVariant/", ""))
        .map((id) => parseInt(id, 10));
      return cleanedVariantIds;
    } catch (error) {
      console.error(
        `Failed to fetch variants for product ${productID}:`,
        error
      );
      return [];
    }
  }

  async function fetchAllVariants(productIDs) {
    const allVariants = {};

    for (const productID of productIDs) {
      try {
        const cleanedVariantIds = await fetchVariants(productID);
        // Ensure only the first two variants are used
        allVariants[productID] = cleanedVariantIds;
      } catch (error) {
        console.error(
          `Error fetching variants for product ${productID}:`,
          error
        );
      }
    }

    return allVariants;
  }

  const productIDs = [7081214509102, 7106060910638];

  fetchAllVariants(productIDs).then((allVariants) => {

    if (!window.autoCartAddProduct) {
      window.autoCartAddProduct = {};
    }

    if (!window.autoCartAddProduct.collections) {
      window.autoCartAddProduct.collections = [];
    }

    if (!window.autoCartAddProduct.products) {
      window.autoCartAddProduct.products = {};
    }

    for (const productID of productIDs) {
      const variants = allVariants[productID] || [];

      window.autoCartAddProduct.products[productID] = {
        id: productID,
        variants: variants, // First two variants
      };
    }
  });

  function autoPopulateProduct(collectionID) {
    fetchProducts(collectionID)
      .then((cleanedProductIds) => {
        if (!window.autoCartAddProduct.collections) {
          window.autoCartAddProduct.collections = [];
        }
        window.autoCartAddProduct.collections.push(...cleanedProductIds);
      })
      .catch((error) => {
        console.error("Error populating product IDs:", error);
      });
  }

  function autoPopulateVariants(productID) {
    fetchVariants(productID)
      .then((cleanedVariantIds) => {
        if (!window.autoCartAddProduct.products) {
          window.autoCartAddProduct.products = {};
        }

        window.autoCartAddProduct.products[productID] = {
          id: productID,
          variants: cleanedVariantIds,
        };
      })
      .catch((error) => {
        console.error("Error populating product variants:", error);
      });
  }

  autoPopulateProduct(262903824430);
  autoPopulateProduct(266654711854);
  // autoPopulateVariants(7081214509102);
})(jQuery_T4NT);
